import React from "react"
import { Dropdown } from "react-bootstrap/"
import { SvgIcon } from "@material-ui/core"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers"

const HeaderDropdownOnMobile = ({ page, setPage }) => {
	const pageCondition = page === "network" ? "Network" : page === "sensors" ? "Sensors" : null

	return (
		<>
			<Dropdown
				style={{
					display: "grid",
					width: "180px",
					background: "#3077d3",
					borderRadius: "4px",
					color: "#f4f4f4"
				}}
				onSelect={eventKey => {
					setPage(eventKey)
				}}
			>
				<Dropdown.Toggle
					className="button_dropdown_header_design_studio"
					style={{
						fontFamily: "Poppins",
						fontWeight: 600
					}}
				>
					{pageCondition}
				</Dropdown.Toggle>

				<Dropdown.Menu className="w-100">
					<Dropdown.Item active={page === "network" ? true : false} eventKey="network">
						<SvgIcon style={{ height: "1.5rem", width: "1.5rem" }}>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
							>
								<path
									d="M17.8397 13.7442L18.6462 14.8184V14.8179C19.5634 14.1298 20.3078 13.2376 20.8205 12.212C21.3332 11.1864 21.6001 10.0556 21.6001 8.90895C21.6001 7.76234 21.3332 6.63148 20.8205 5.60588C20.3078 4.58028 19.5634 3.68811 18.6462 3L17.8397 4.07429C18.5903 4.63722 19.1996 5.3672 19.6192 6.20639C20.0388 7.04559 20.2573 7.97096 20.2573 8.90922C20.2573 9.84748 20.0388 10.7729 19.6192 11.6121C19.1996 12.4512 18.5903 13.1812 17.8397 13.7442ZM5.75397 14.8182C4.83685 14.1301 4.09249 13.2379 3.57982 12.2124C3.06716 11.1868 2.80026 10.056 2.80026 8.90942C2.80026 7.76285 3.06716 6.63203 3.57982 5.60646C4.09249 4.58089 4.83685 3.68874 5.75397 3.00063L6.56009 4.07479C5.80952 4.63772 5.20032 5.36767 4.78074 6.20684C4.36116 7.04601 4.14272 7.97134 4.14272 8.90955C4.14272 9.84777 4.36116 10.7731 4.78074 11.6123C5.20032 12.4514 5.80952 13.1814 6.56009 13.7443L5.75397 14.8182ZM7.72331 12.4115C7.23058 11.9706 6.83642 11.4308 6.56655 10.8272C6.29669 10.2236 6.1572 9.56982 6.1572 8.90864C6.1572 8.24747 6.29669 7.59372 6.56655 6.99012C6.83642 6.38652 7.23058 5.84665 7.72331 5.40576L8.61899 6.40619C8.26692 6.72109 7.98525 7.10673 7.79241 7.53793C7.59957 7.96912 7.49989 8.43616 7.49989 8.90851C7.49989 9.38086 7.59957 9.8479 7.79241 10.2791C7.98525 10.7103 8.26692 11.0959 8.61899 11.4108L7.72331 12.4115ZM12.8715 18.9806V11.5948H13.5429C13.899 11.5944 14.2403 11.4528 14.492 11.2011C14.7438 10.9493 14.8854 10.608 14.8858 10.252V7.56626C14.8854 7.21024 14.7438 6.86891 14.492 6.61717C14.2403 6.36542 13.899 6.22381 13.5429 6.2234H10.8572C10.5012 6.22381 10.1599 6.36542 9.90812 6.61717C9.65637 6.86891 9.51476 7.21024 9.51435 7.56626V10.252C9.51476 10.608 9.65637 10.9493 9.90812 11.2011C10.1599 11.4528 10.5012 11.5944 10.8572 11.5948H11.5286V18.9806H2.80005V20.3234H21.6001V18.9806H12.8715ZM10.8572 7.56626H13.5429L13.5439 10.252H10.8572V7.56626ZM15.7808 11.4115L16.6765 12.4119V12.4122C17.1692 11.9713 17.5635 11.4315 17.8334 10.8278C18.1033 10.2242 18.2428 9.57048 18.2428 8.90928C18.2428 8.24808 18.1033 7.59432 17.8334 6.99071C17.5635 6.38711 17.1692 5.84724 16.6765 5.40639L15.7808 6.40683C16.1329 6.72169 16.4146 7.10733 16.6075 7.53853C16.8003 7.96973 16.9 8.43678 16.9 8.90914C16.9 9.38151 16.8003 9.84856 16.6075 10.2798C16.4146 10.711 16.1329 11.0966 15.7808 11.4115Z"
									fill={page === "network" ? "#ffffff" : "#3077d3"}
								/>
							</svg>
						</SvgIcon>{" "}
						<span className="ml-4">Network</span>
					</Dropdown.Item>
					<Dropdown.Item active={page === "sensors" ? true : false} eventKey="sensors">
						<SVG
							src={toAbsoluteUrl("/media/svg/icons/General/sensors-manage-infra-icon.svg")}
							style={{
								height: "1.5rem",
								width: "1.5rem",
								fill: page === "sensors" ? "#ffffff" : "#3077d3"
							}}
						/>
						<span className="ml-4">Sensors</span>
					</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
		</>
	)
}

export default HeaderDropdownOnMobile
